import { Link } from "react-router-dom";
import {
  Briefcase,
  Rocket,
  HeartHandshake,
  Laptop2,
  Coffee,
  GraduationCap,
  Code2,
  Megaphone,
  Headphones,
  Wrench,
  MapPin,
  ArrowRight,
  Mail,
} from "lucide-react";
import "./MarketingPage.css";

const OPENINGS = [
  {
    title: "Développeur·se Full-Stack (React / Node)",
    type: "CDI",
    location: "Paris / Remote France",
    icon: <Code2 size={20} />,
    desc: "Rejoignez l'équipe produit pour faire évoluer la plateforme et le module ProMeet Missions.",
  },
  {
    title: "Responsable marketing & growth",
    type: "CDI",
    location: "Paris / Hybride",
    icon: <Megaphone size={20} />,
    desc: "Pilotez l'acquisition pros & clients, le contenu et nos campagnes locales.",
  },
  {
    title: "Customer success — pros automobile",
    type: "CDI",
    location: "Full-remote France",
    icon: <Headphones size={20} />,
    desc: "Accompagnez les garages et indépendants dans leurs premières missions sur la plateforme.",
  },
  {
    title: "Stage / Alternance — Product Design",
    type: "Stage / Alt.",
    location: "Paris / Remote",
    icon: <Laptop2 size={20} />,
    desc: "Concevez les futures fonctionnalités web & mobile aux côtés de notre lead design.",
  },
];

export default function CareersPage() {
  return (
    <div className="mkt-shell">
      <div className="mkt-container">
        {/* ========= HERO ========= */}
        <section className="mkt-hero">
          <div className="mkt-hero__inner">
            <div className="mkt-hero__icon">
              <Briefcase size={36} strokeWidth={2.2} />
            </div>
            <div className="mkt-hero__copy">
              <h1>Rejoignez l'aventure ProMeetService</h1>
              <p>
                Nous construisons la plateforme de référence pour les pros du service et de
                l'automobile. Si vous aimez les produits simples, beaux et utiles — on doit
                se parler.
              </p>
              <div className="mkt-hero__actions">
                <a className="mkt-btn mkt-btn--primary" href="mailto:jobs@promeetservice.fr?subject=Candidature%20spontanée">
                  <Mail size={16} /> Candidature spontanée
                </a>
                <Link className="mkt-btn mkt-btn--ghost" to="/about">
                  À propos de nous
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* ========= Pourquoi nous rejoindre ========= */}
        <h2 className="mkt-section-title"><HeartHandshake size={20} /> Pourquoi nous rejoindre</h2>
        <section className="mkt-grid-2">
          <div className="mkt-feature">
            <div className="mkt-feature__icon"><Rocket size={22} /></div>
            <div>
              <h3>Un produit qui décolle</h3>
              <p>Plus de 1 200 pros actifs, des dizaines de milliers de RDV traités, et un nouveau module B2B qui ouvre un marché énorme.</p>
            </div>
          </div>
          <div className="mkt-feature mkt-feature--info">
            <div className="mkt-feature__icon"><Laptop2 size={22} /></div>
            <div>
              <h3>Full-remote friendly</h3>
              <p>Bureaux à Paris, mais on travaille où l'on est le plus efficace. Outils modernes, asynchrone par défaut.</p>
            </div>
          </div>
          <div className="mkt-feature mkt-feature--violet">
            <div className="mkt-feature__icon"><GraduationCap size={22} /></div>
            <div>
              <h3>Apprentissage continu</h3>
              <p>Budget formation annuel, conférences, partages internes hebdomadaires.</p>
            </div>
          </div>
          <div className="mkt-feature mkt-feature--success">
            <div className="mkt-feature__icon"><Coffee size={22} /></div>
            <div>
              <h3>Une équipe humaine</h3>
              <p>Petite équipe ambitieuse, transparente, où chaque voix compte vraiment.</p>
            </div>
          </div>
        </section>

        {/* ========= Postes ouverts ========= */}
        <h2 className="mkt-section-title"><Briefcase size={20} /> Postes ouverts</h2>
        <section style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {OPENINGS.map((o) => (
            <article key={o.title} className="mkt-card" style={{ padding: 18 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
                <div
                  style={{
                    width: 44, height: 44, borderRadius: 12,
                    background: "rgba(15, 118, 110, 0.10)",
                    color: "var(--color-primary-hover)",
                    display: "grid", placeItems: "center",
                    border: "1px solid rgba(15, 118, 110, 0.14)",
                    flexShrink: 0,
                  }}
                >
                  {o.icon}
                </div>
                <div style={{ flex: 1, minWidth: 220 }}>
                  <h3 style={{ margin: 0, fontSize: "1.05rem", color: "var(--espresso)", fontWeight: 800 }}>
                    {o.title}
                  </h3>
                  <p style={{ margin: "4px 0 0", color: "var(--text-secondary)", fontSize: 14 }}>
                    {o.desc}
                  </p>
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 4,
                    padding: "5px 10px", borderRadius: 999,
                    background: "rgba(15, 118, 110, 0.10)",
                    color: "var(--color-primary-hover)",
                    fontSize: 12, fontWeight: 700,
                  }}>
                    <Briefcase size={11} /> {o.type}
                  </span>
                  <span style={{
                    display: "inline-flex", alignItems: "center", gap: 4,
                    padding: "5px 10px", borderRadius: 999,
                    background: "var(--cream-warm)",
                    color: "var(--text-secondary)",
                    fontSize: 12, fontWeight: 700,
                  }}>
                    <MapPin size={11} /> {o.location}
                  </span>
                </div>
                <a
                  className="mkt-btn mkt-btn--outline"
                  href={`mailto:jobs@promeetservice.fr?subject=Candidature%20-%20${encodeURIComponent(o.title)}`}
                >
                  Postuler <ArrowRight size={14} />
                </a>
              </div>
            </article>
          ))}
        </section>

        {/* ========= Process ========= */}
        <h2 className="mkt-section-title"><Wrench size={20} /> Notre process de recrutement</h2>
        <section className="mkt-steps">
          <div className="mkt-step">
            <h3>Candidature</h3>
            <p>Envoyez votre CV à <a className="mkt-link" href="mailto:jobs@promeetservice.fr">jobs@promeetservice.fr</a> — un mot suffit, on regarde tout.</p>
          </div>
          <div className="mkt-step">
            <h3>Premier échange</h3>
            <p>30 min de visio avec un membre de l'équipe pour comprendre votre projet.</p>
          </div>
          <div className="mkt-step">
            <h3>Entretien technique</h3>
            <p>Un cas concret, pas un examen-piège. On regarde comment vous raisonnez.</p>
          </div>
          <div className="mkt-step">
            <h3>Rencontre équipe</h3>
            <p>Une heure avec les futurs collègues — fit humain et alignement produit.</p>
          </div>
        </section>

        {/* ========= CTA ========= */}
        <section className="mkt-cta">
          <div>
            <h3>Pas de poste ouvert qui vous corresponde ?</h3>
            <p>Envoyez-nous votre candidature spontanée, on garde toutes les pépites.</p>
          </div>
          <div className="mkt-cta__actions">
            <a className="mkt-btn mkt-btn--primary" href="mailto:jobs@promeetservice.fr?subject=Candidature%20spontanée">
              <Mail size={16} /> jobs@promeetservice.fr
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}
